import { render, staticRenderFns } from "./ModalCopy.vue?vue&type=template&id=0b6dad8f&"
import script from "./ModalCopy.vue?vue&type=script&lang=js&"
export * from "./ModalCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports